import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import Avatar from 'components/ui/Avatar';

import BotApi from 'api/bot';
import Header from 'components/ui/Header';
import BotAddButton from './BotAddButton';

const BotExploreHeader = ({ botId }) => {
  const { t } = useTranslation();
  const { data } = useQuery(['explore_bot', botId], () => BotApi.get(botId));
  if (!data) {
    return null;
  }

  data.price = parseFloat(data.price);

  const price_text = !data.price ? t('explore.price.free') : t('explore.price.paid');
  const price_classname = !data.price ? 'text-success' : 'text-muted';

  const category = data.category || {};

  return (
    <>
      <Header>
        <div style={{ position: 'absolute' }}>
          <Avatar name={data.name} src={data.profile_image} size={150} sourceTTL={0} className="shadow rounded" round="20px" />
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center" style={{ marginLeft: 170 }}>
            <div className="me-3">
              <Link to="/marketplace">
                <FiArrowLeft size={24} />
              </Link>
            </div>

            <div>
              <div>
                <small className="text-uppercase">
                  <Link to="/bots">bots</Link> / {category.name || t('bots.categories.none')}
                </small>
              </div>
              <h2 className="m-0 p-0 fw-lighter">{data.name}</h2>
            </div>
          </div>

          <div>
            <BotAddButton botId={botId} />
          </div>
        </div>
      </Header>

      <div className="container mt-4" style={{ paddingLeft: 190, marginBottom: 60 }}>
        <h5 className={`${price_classname}`}>{price_text}</h5>
      </div>
    </>
  );
};

export default BotExploreHeader;
